module.exports = __webpack_public_path__ + "static/media/icon-error-dark-exclamation-mark.2218d646.svg";